import styled from "styled-components";
import { Device } from "@pepdirect/v3/styles/screenSizes";

export const StyledPageContainer = styled.div`
  overflow: hidden;
  flex: 1 0 auto;
`;

export const StyledBanner = styled.div`
  position: absolute;
  width: 100%;
  z-index: 100;
  top: 60px; /* header height */

  @media ${Device.mobile} {
    top: 50px; /* header height mobile */
  }
`;

export const StyledPage = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding: 60px 80px 0;

  @media ${Device.mobile} {
    padding: 40px 0px 0;
  }
`;

export const StyledContent = styled.div`
  max-width: 1020px;
  width: 100%;
`;

export const StyledFooter = styled.div`
  padding: 100px 80px 40px;

  @media ${Device.mobile} {
    padding: 60px 20px 40px;
    display: flex;
    justify-content: center;
  }
`;
